export default function AboutSkills(props) {
    return (
            <article>
                {/* <img src={props.img} alt={props.img} /> */}
                <i className={props.logo}></i>
                <p>{props.lang}</p>
            </article>
    );
}